import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import Hero from "@/pages/home/components/Hero";
import CategoryStrip from "@/pages/home/components/CategoryStrip";
import StreamSection from "@/pages/home/components/StreamSection";
import CredibilitySection from "@/pages/home/components/CredibilitySection";
import FaqSection from "@/pages/home/components/FaqSection";
import SubscribeSection from "@/pages/home/components/SubscribeSection";
import useSeo, { SITE_NAME, SITE_ORIGIN } from "@/hooks/useSeo";
import { faqItems } from "@/mocks/faq";

const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: `${SITE_ORIGIN}/`,
    description:
      "聚焦热点内幕独家爆料，汇总知情人透露的小道消息与秘密流出内容，一手信息持续更新。",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: `${SITE_ORIGIN}/rumors?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: `${SITE_ORIGIN}/`,
    email: "tips@redian-neimu.example.com",
    description: "热点事件内幕爆料与知情人线索整理平台。",
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  },
];

export default function Home() {
  useSeo({
    title: "热点内幕 - 独家爆料｜知情人透露｜一手信息持续更新",
    description:
      "热点内幕聚焦热点事件的独家爆料，汇总知情人透露的小道消息与秘密流出内容，覆盖娱乐、商业、互联网与职场话题，一手信息持续更新。",
    keywords: "热点内幕,热点内幕独家爆料,热点内幕知情人透露,热点内幕一手信息,热点内幕小道消息",
    path: "/",
    jsonLd: homeJsonLd,
  });

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <Hero />
        <CategoryStrip />
        <StreamSection />
        <CredibilitySection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}